import {Injectable} from '@angular/core';
import {AppConstants} from '../shared/app.constants';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class SmsBlastService {

  constructor(private appConstants: AppConstants, private http: HttpClient, private auth: AuthService) {
  }

  sendSMS(body): Observable<any> {
    const url = environment.apiBase + 'sms/blast';
    let headers = this.auth.getAuthorizationHeaders();
    headers = headers.delete('Accept');
    return this.http.post(url, body, {headers: headers, responseType: 'text'})
      .map(res => res)
      .catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/sms-blast/sms-blast.service.ts